import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Radio from '../../../CommonComponents/Radio/Radio';
import Loader from '../Common/Loader';
import { getOrder } from '../../../actionCreators/order';
import * as lensPackageUpgradeApiCall from '../../../actionCreators/lensPackageUpgrade';
import { enterDataFunc, getPowers, enterErrorFunc } from '../../../actionCreators/success';
import SideBarPopup from '../SideBarPopup/SideBarPopup';
import LensPackages from './LensPackages';
import Prescriptions from './Prescriptions';
import ProductDetails from './ProductDetails';
import { formatDate } from '../../../utils/helper';

import './LensPackageUpgrade.scss';
import UserDetails from './UserDetails';

const LensPackageUpgrade = props => {
  const {
    orderDetails,
    powersDetail,
    match,
    lensPackageDetails,
    enterData,
    isUpdatePowerTypeCallSuccess,
    isUpdatePackageCallSuccess,
    isUpdatePrescriptionCallSuccess,
    loading,
    dataLocale,
    errorMsg,
  } = props;
  const {
    PACKAGE_PRICE,
    COVERED_BENEFITS,
    SELECT_A_NEW_LENS_PACKAGE_FOR_THE_SELECTED_LENS,
    VIEW_LENS_PACKAGES,
    ORDER,
    LENS_DETAILS,
    CURRENT_SELECTED_LENS,
    PACKAGE_DETAILS,
    CURRENT_SELECTED_PACKAGE,
    POWER_DETAILS,
    CANCEL,
    CONFIRM,
    SELECTED_LENS_PACKAGE,
    SELECT,
    CHANGE,
    RESET,
  } = dataLocale;

  const [openSideBarPopup, setOpenSideBarPopup] = useState(false);
  const [defaultLensPackageData, setDefaultLensPackageData] = useState({});
  const [currentItemData, setCurrentItemData] = useState();
  const [lensType, setLensType] = useState('');
  const [packageDetailId, setPackageDetailId] = useState();
  const [showSelectPackage, setShowSelectPackage] = useState(true); // Used to show select pacakge UI in Package details
  const [reflectDropdown, setReflectDropdown] = useState(false); // To reflect prescription dropdown so that values can rerender
  const [touchFields, setTouchFields] = useState({
    powerType: false,
    package: false,
    prescription: false,
  });

  useEffect(() => {
    // Used to fetch order details
    props?.getOrder?.({ orderId: match?.params?.orderId, isLensPackageUpgrade: true });
    // Used to fetch lens and package details
  }, []);

  useEffect(() => {
    if (match?.params?.itemId && !lensPackageDetails && orderDetails) {
      props?.lensPackageUpgradeApiCall?.getLensPackageDetails(
        match?.params?.orderId,
        match?.params?.itemId,
        orderDetails?.result?.metadata?.apiClient
      );
    }
    if (orderDetails && !match?.params?.itemId) {
      const itemId = orderDetails?.result?.items?.[0]?.id + '';
      if (itemId)
        window.location.pathname = `lens-package-upgrade/${match?.params?.orderId}/${itemId}`;
    }
  }, [orderDetails]);

  useEffect(() => {
    if (lensPackageDetails?.packages && orderDetails?.result) {
      orderDetails?.result?.items?.forEach(item => {
        if (item.id + '' === match?.params?.itemId + '') {
          setLensType(item?.prescription?.powerType);
          setPackageDetailId(item?.options?.[0]?.oid);
          props?.enterDataFunc({
            left: item?.prescription?.left || {},
            right: item?.prescription?.right || {},
          });
          setDefaultLensPackageData({
            lensType: item?.prescription?.powerType,
            packageDetailId: item?.options?.[0]?.oid,
            productId: item?.productId,
          });
          setCurrentItemData(item);
          // To show select package UI in package detail box
          lensPackageDetails?.packages?.forEach(detail => {
            if (detail?.id?.toLowerCase() === item?.prescription?.powerType?.toLowerCase()) {
              for (let j = 0; j < detail?.packages?.length; j++) {
                if (detail?.packages?.[j]?.id === item?.options?.[0]?.oid) {
                  setShowSelectPackage(false);
                }
              }
            }
          });
          // To get power details
          if (item?.prescription?.powerType?.toLowerCase() !== 'zero_power') {
            props.getPowers(item?.productId, item?.prescription?.powerType);
          }
        }
      });
    }
  }, [orderDetails, lensPackageDetails]);
  // When user select lens type in Lens Detail
  const handleLensName = value => {
    setLensType(value);
    setPackageDetailId();
    setShowSelectPackage(true);
    props.enterDataFunc({ left: {}, right: {} });
    props.enterErrorFunc('');
    // To get powers according to new lens
    props.getPowers(defaultLensPackageData?.productId, value);
    // To reflect enterData in Prescreption
    setReflectDropdown(true);
    setTimeout(() => {
      setReflectDropdown(false);
    }, 1);
    if (touchFields && touchFields.powerType !== true)
      setTouchFields({ ...touchFields, powerType: true });
  };
  // When user select package in sidebar popup
  const handlePackageDetail = packageId => {
    setPackageDetailId(packageId);
    setShowSelectPackage(false);
    // props.enterDataFunc({ left: { }, right: { } });
    // To reflect enterData in Prescreption
    setReflectDropdown(true);
    setTimeout(() => {
      setReflectDropdown(false);
    }, 1);
    // To close sidebar popup when user select package detail
    setOpenSideBarPopup(false);
    if (touchFields && touchFields.package !== true)
      setTouchFields({ ...touchFields, package: true });
  };

  // Update power type API call
  const callUpdatePowerType = () => {
    const payload = {
      orderId: match?.params?.orderId,
      itemId: match?.params?.itemId,
      from: defaultLensPackageData?.lensType?.toLowerCase(),
      to: lensType?.toLowerCase(),
    };
    props?.lensPackageUpgradeApiCall?.updatePowerType(payload);
  };
  // Update package API call
  const callUpdatePackage = () => {
    const payload = {
      orderId: match?.params?.orderId,
      itemId: match?.params?.itemId,
      from: defaultLensPackageData?.lensType?.toLowerCase(),
      to: lensType?.toLowerCase(),
    };
    const bodyData = {
      packageId: packageDetailId,
      powerType: lensType?.toLowerCase(),
      productId: defaultLensPackageData?.productId,
      updatedBy: orderDetails?.result?.shippingAddress?.email,
      source: 'VSM',
    };
    props?.lensPackageUpgradeApiCall?.updatePackage(payload, bodyData);
  };

  // Execute when update powertype api call done
  useEffect(() => {
    if (isUpdatePowerTypeCallSuccess && touchFields?.package) {
      callUpdatePackage();
    }
  }, [isUpdatePowerTypeCallSuccess]);
  // Update prescription API call
  const callUpdatePrescription = () => {
    const payload = {
      orderId: match?.params?.orderId,
      itemId: match?.params?.itemId,
      email: orderDetails?.result?.shippingAddress?.email,
    };
    const bodyData = {
      powerType: lensType?.toUpperCase(),
      updatedBy: orderDetails?.result?.shippingAddress?.email,
      source: 'VSM',
      right: enterData?.right,
      left: enterData?.left,
      userName: `${orderDetails?.result?.shippingAddress?.firstName} ${orderDetails?.result?.shippingAddress?.lastName}`,
    };
    props?.lensPackageUpgradeApiCall?.updatePrescription(payload, bodyData);
  };
  // Execute when update package api call done
  useEffect(() => {
    if (isUpdatePackageCallSuccess && lensType?.toLowerCase() !== 'zero_power') {
      callUpdatePrescription();
    } else if (isUpdatePackageCallSuccess && lensType?.toLowerCase() === 'zero_power') {
      window?.location?.reload();
    }
  }, [isUpdatePackageCallSuccess]);

  // Execute when update package api call done
  useEffect(() => {
    if (isUpdatePrescriptionCallSuccess) {
      // props?.lensPackageUpgradeApiCall?.resetUpdateFields();
      window?.location?.reload();
    }
  }, [isUpdatePrescriptionCallSuccess]);

  // Handle Submit
  const onSubmit = () => {
    if (touchFields?.powerType) {
      callUpdatePowerType();
      setTouchFields({ ...touchFields, powerType: false });
    } else if (touchFields?.package) {
      callUpdatePackage();
      setTouchFields({ ...touchFields, package: false });
    } else if (touchFields?.prescription && lensType?.toLowerCase() !== 'zero_power') {
      callUpdatePrescription();
      setTouchFields({ ...touchFields, prescription: false });
    }
  };

  // To show lens detail
  const showLensDetail = () => {
    return lensPackageDetails.packages.map((value, index) => {
      return (
        <div
          key={index}
          className={`${index !== lensPackageDetails?.packages?.length - 1 ? 'margin-b36' : ''}`}
        >
          <Radio
            readOnly
            checked={value.id === lensType?.toLowerCase()}
            onClick={() => handleLensName(value.id)}
          />
          <span className="margin-l12">{value.label}</span>
        </div>
      );
    });
  };

  // To show current package detail
  const showPackageDetail = () => {
    return lensPackageDetails.packages.map(detail => {
      if (detail.id === lensType.toLowerCase()) {
        return detail.packages.map((value, index) => {
          if (value.id === packageDetailId) {
            return (
              <div key={index} className="display-flex">
                <div>
                  <Radio checked={value.id === packageDetailId} />
                </div>
                <div className="margin-l12 width-max">
                  <div>{value.label}</div>
                  <div className="fs18 fw400">
                    {PACKAGE_PRICE}: ₹ {value.prices[3].price}
                  </div>
                  <div className="covered-benefits margin-t20">
                    <div className="color-light-grey fs13 fw500 margin-b11">{COVERED_BENEFITS}</div>
                    {value?.specificationList?.map(title => {
                      return (
                        <div
                          key={parseInt(Math.random() * 100000, 10)}
                          className="fs14 fw400 display-flex align-items-center margin-b5"
                        >
                          <i
                            className="fa fa-check icon-checked fs15 margin-r11"
                            style={{ color: '#4ECED4' }}
                          ></i>
                          {title.title}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          }
          return '';
        });
      }
      return '';
    });
  };
  // UI to show select package
  const selectPackageUI = () => {
    return (
      <div className="select-package">
        <div className="margin-b20">{SELECT_A_NEW_LENS_PACKAGE_FOR_THE_SELECTED_LENS}</div>
        <div
          className={`button ${
            lensPackageDetails?.isPowerTypeUpdateAvailable + '' === 'false' ? 'button-disable' : ''
          }`}
          onClick={() => setOpenSideBarPopup(true)}
        >
          {VIEW_LENS_PACKAGES}
        </div>
      </div>
    );
  };

  return (
    <div className="main">
      {/* Loader */}
      {loading && <Loader />}

      {/* Sidebar Popup */}
      {openSideBarPopup && (
        <SideBarPopup
          dialogClassName="bg-grey overflow-auto"
          open={openSideBarPopup}
          onClose={setOpenSideBarPopup}
        >
          {/* Packages */}
          <LensPackages
            currentItemData={currentItemData}
            dataLocale={dataLocale}
            handlePackageDetail={handlePackageDetail}
            lensPackageDetails={lensPackageDetails}
            lensType={lensType}
            orderDetails={orderDetails}
            packageDetailId={packageDetailId}
            setOpenSideBarPopup={setOpenSideBarPopup}
          />
        </SideBarPopup>
      )}

      {/* Header */}
      <div className="header-wrapper display-flex justify-space-between">
        <div>
          <span className="back-arrow" onClick={() => window?.history?.back()}>
            <i className="fa fa-arrow-left fs11 cursor-pointer" />
          </span>
          <div>
            <span className="fs14 fw700 margin-r5">
              {ORDER} #{match?.params?.orderId}
            </span>
            <span className="fs12 fw400">
              {formatDate(orderDetails?.result?.createdAt, 'D MMM', 'year')}
            </span>
          </div>
        </div>
        <div>
          <div className="button" onClick={() => window?.location?.reload()}>
            {RESET}
          </div>
        </div>
      </div>
      {/* User Details */}
      {orderDetails?.result?.shippingAddress && (
        <UserDetails dataLocale={dataLocale} orderDetails={orderDetails} />
      )}
      <div className="body">
        {/* Product Details */}
        {currentItemData && orderDetails?.result && (
          <ProductDetails
            currentItemData={currentItemData}
            dataLocale={dataLocale}
            match={match}
            orderDetails={orderDetails}
          />
        )}
        <div className="display-flex fs16 body-bottom-margin">
          <div className="flex-1 margin-r8">
            {/* Lens Details */}
            {lensPackageDetails && lensPackageDetails.packages && (
              <div className="product-detail-wrapper margin-b16">
                <div className="title-wrapper">{LENS_DETAILS}</div>
                <div className="seperator"></div>
                <div
                  className={`${
                    lensPackageDetails &&
                    lensPackageDetails.isPowerTypeUpdateAvailable + '' === 'false'
                      ? 'disable'
                      : ''
                  } body-wrapper`}
                >
                  <div className="fs14 fw500 margin-b15">{CURRENT_SELECTED_LENS}</div>
                  {showLensDetail()}
                </div>
              </div>
            )}
            {/* Package Details */}
            <div className="product-detail-wrapper">
              <div className="title-wrapper display-flex justify-space-between align-items-center">
                <div>{PACKAGE_DETAILS}</div>
                <div
                  className={`change-text fs14 fw500 cursor-pointer ${
                    lensPackageDetails &&
                    lensPackageDetails.isPowerTypeUpdateAvailable + '' === 'false'
                      ? 'disable'
                      : ''
                  }`}
                  onClick={() => setOpenSideBarPopup(true)}
                >
                  {!showSelectPackage && lensPackageDetails?.packages ? CHANGE : SELECT}
                </div>
              </div>
              <div className="seperator"></div>
              <div className="body-wrapper">
                {!showSelectPackage && lensPackageDetails?.packages ? (
                  <>
                    <div className="fs14 fw500 margin-b15">{CURRENT_SELECTED_PACKAGE}</div>
                    {showPackageDetail()}
                  </>
                ) : (
                  <>
                    <div className="fs14 fw500 margin-b15">{SELECTED_LENS_PACKAGE}</div>
                    {selectPackageUI()}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="flex-1 margin-l8">
            {/* Power Details */}
            {((!packageDetailId && lensType?.toLowerCase() === 'contact_lens') ||
              (packageDetailId && lensType?.length > 0)) &&
              orderDetails?.result &&
              powersDetail?.result && (
                <div className="product-detail-wrapper margin-b16">
                  <div className="title-wrapper">{POWER_DETAILS}</div>
                  <div className="seperator"></div>
                  <div className="body-wrapper">
                    {!reflectDropdown && (
                      <Prescriptions
                        currentItemData={currentItemData}
                        lensType={lensType}
                        setTouchFields={setTouchFields}
                        touchFields={touchFields}
                      />
                    )}
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
      {/* Footer */}
      <div className={`button-wrapper width-max ${openSideBarPopup ? '' : 'on-top'}`}>
        <div className="button-reverse margin-r10" onClick={() => window?.history?.back()}>
          {CANCEL}
        </div>
        <div
          className={`button ${
            ((!packageDetailId || (packageDetailId && packageDetailId.length === 0)) &&
              powersDetail?.result &&
              lensType?.toLowerCase() !== 'contact_lens') ||
            (errorMsg && errorMsg.length >= 0)
              ? 'button-disable'
              : ''
          } ${
            touchFields?.powerType || touchFields?.package || touchFields?.prescription
              ? ''
              : 'button-disable'
          }`}
          onClick={() => onSubmit()}
        >
          {CONFIRM}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  // localeInfo: state.common.localeInfo,
  dataLocale: state.locale,
  lensPackageDetails: state.lensPackageUpgrade.lensPackageDetails,
  orderDetails: state?.order?.orderDetails,
  powersDetail: state.success.powersDetail,
  enterData: state.success.enterData,
  errorMsg: state.success.errorMsg,
  isUpdatePowerTypeCallSuccess: state.lensPackageUpgrade.isUpdatePowerTypeCallSuccess,
  isUpdatePackageCallSuccess: state.lensPackageUpgrade.isUpdatePackageCallSuccess,
  isUpdatePrescriptionCallSuccess: state.lensPackageUpgrade.isUpdatePrescriptionCallSuccess,
  loading: state.lensPackageUpgrade.loading,
});
const mapDispatchToProps = dispatch => ({
  getOrder: bindActionCreators(getOrder, dispatch),
  lensPackageUpgradeApiCall: bindActionCreators(lensPackageUpgradeApiCall, dispatch),
  enterDataFunc: bindActionCreators(enterDataFunc, dispatch),
  enterErrorFunc: bindActionCreators(enterErrorFunc, dispatch),
  getPowers: bindActionCreators(getPowers, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LensPackageUpgrade);
